// 枚举定义

// 身份类型

export enum EnumIdType {
  /**
   * "俱乐部顾客"
   */
  ROLE_CLUB_CUSTOMER = 'ROLE_CLUB_CUSTOMER',
  /**
   * "俱乐部陪玩"
   */
  ROLE_CLUB_PLAYER = 'ROLE_CLUB_PLAYER',
  /**
   * "俱乐部接待"
   */
  ROLE_CLUB_WAITER = 'ROLE_CLUB_WAITER',
  /**
   * "俱乐部管理员"
   */
  ROLE_CLUB_ADMIN = 'ROLE_CLUB_ADMIN',
  /**
   * "联盟管理员"
   */
  ROLE_LEAGUE_ADMIN = 'ROLE_LEAGUE_ADMIN',
  /**
   * 俱乐部超级管理员
   */
  ROLE_CLUB_SUPER_ADMIN = 'ROLE_CLUB_SUPER_ADMIN',
}

/**
 * 角色枚举与展示名称的映射对象
 * @description 键为 EnumIdType 枚举值，值为对应的中文展示名称
 */
export const ROLE_NAMES_MAP = {
  [EnumIdType.ROLE_CLUB_CUSTOMER]: '俱乐部顾客',
  [EnumIdType.ROLE_CLUB_PLAYER]: '俱乐部陪玩',
  [EnumIdType.ROLE_CLUB_WAITER]: '俱乐部接待',
  [EnumIdType.ROLE_CLUB_ADMIN]: '俱乐部管理员',
  [EnumIdType.ROLE_LEAGUE_ADMIN]: '联盟管理员',
  [EnumIdType.ROLE_CLUB_SUPER_ADMIN]: '俱乐部超管',
}

// 支付状态
export enum EnumPaymentStatus {
  /**
   * 待支付
   */
  PENDING_PAYMENT = 1,
  /**
   * 支付中
   */
  PAYING,
  /**
   * 已支付
   */
  PAID,
  /**
   * 已退款
   */
  REFUNDED,
}

// 订单状态
export enum EnumOrderStatus {
  /**
   * 待确认
   */
  // PENDING_CONFIRM = 1,
  /**
   * 待支付
   */
  PENDING_PAYMENT = 0,
  /**
   *支付中
   */
  // PAYING,
  /**
   * 已支付/待开始
   */
  PAID = 1,
  /**
   *服务进行中
   */
  // IN_SERVICE,
  /**
   * 服务中/待确认
   */
  END_SERVICE = 2,
  /**
   * 已完成
   */
  COMPLETED = 3,
  /**
   * 已取消
   */
  CANCELLED = 5,
  /**
   * 己关闭
   */
  // CLOSED,
  /**
   * 退款发起
   */
  // REFUND_REQUEST,
  /**
   * 退款中
   */
  // REFUNDING,
  /**
   * 已退款
   */
  REFUNDED = 4,
  /**
   * 部分退款
   */
  // PARTIAL_REFUNDED = 13,
}

// 退款原因
export enum EnumReasonRefund {
  /** 1 - 个人原因 */
  PersonalReason = 1,
  /** 2 - 服务问题 */
  ServiceProblem = 2,
  /** 3 - 其他 */
  Other = 3,
}

//
export enum EnumPaymentType {
  /** 微信支付 */
  WX = 'WX',
  /** 余额支付 */
  BALANCE = 'BALANCE',
  /** 收益支付 */
  INCOME = 'INCOME',
  /** 支付宝支付 */
  ALIPAY = 'ALIPAY',
  /** 存单抵扣 */
  STOCK = 'STOCK',
}

export const PAYMENT_TYPE_LABELS = {
  [EnumPaymentType.WX]: '微信',
  [EnumPaymentType.BALANCE]: '余额',
  [EnumPaymentType.INCOME]: '收益',
  [EnumPaymentType.ALIPAY]: '其它支付',
  [EnumPaymentType.STOCK]: '存单抵扣',
}

/** V2 支付状态（字符串枚举） */
export enum EnumV2PaymentStatus {
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PAYING = 'PAYING',
  PAID = 'PAID',
  CANCELED = 'CANCELED',
  REFUNDING = 'REFUNDING',
  REFUNDED = 'REFUNDED',
}

// 抽成类型
export enum EnumCommissionType {
  /**
   * 按比例抽成
   */
  PERCENTAGE = 1,
  /**
   * 按固定值抽成
   */
  FIXED,
}

// 抽成类型
export const COMMISSION_TYPE_LABELS = {
  [EnumCommissionType.PERCENTAGE]: '按比例',
  [EnumCommissionType.FIXED]: '固定值',
}

// 项目配置状态
export enum EnumPlayerServiceApprovalsStatus {
  /**
   * 待审核
   */
  PENDING = 'PENDING',
  /**
   * 已通过
   */
  APPROVED = 'APPROVED',
  /**
   * 拒绝
   */
  REJECTED = 'REJECTED',
  /**
   * 已取消
   */
  CANCELED = 'CANCELED',
}

// 优惠券类型
export enum EnumCouponType {
  /**
   * 定额减免券
   */
  AMOUNT = 'AMOUNT',
  /**
   * 折扣券
   */
  PERCENT = 'PERCENT',
}

// 优惠券状态
export enum EnumCouponStatus {
  /**
   * 可用
   */
  AVAILABLE = 'AVAILABLE',
  /**
   * 已使用
   */
  USED = 'USED',
  /**
   * 已收回
   */
  REVOKED = 'REVOKED',
  /**
   * 已过期
   */
  EXPIRED = 'EXPIRED',
}

// 优惠承担方式
export enum EnumCommissionAssumption {
  /**
   * 俱乐部全部承担
   */
  MERCHANT_BEARING = 0,
  /**
   * 俱乐部和陪玩按比例承担
   */
  AVERAGE = 1,
}

// 排序
export enum EnumSortBy {
  NONE = '',
  ASC = 'asc',
  DESC = 'desc',
}

// 账户状态
export enum EnumClubMemberStatus {
  /**
   * 封禁
   */
  BANNED,
  /**
   * 未封禁
   */
  UN_BANED,
}

// 退款原因
export enum EnumRefundType {
  /**
   * 个人原因
   */
  PERSONAL = 'PERSONAL',
  /**
   * 服务问题
   */
  SERVICE = 'SERVICE',
  /**
   * 其他
   */
  OTHER = 'OTHER',
}

// 红包类型
export enum EnumRedPacketType {
  /**
   * 拼手气
   */
  LUCKY = 'LUCKY',
  /**
   * 普通/等额
   */
  NORMAL = 'NORMAL',
  /**
   * 专属
   */
  EXCLUSIVE = 'EXCLUSIVE',
}

export const RED_PACKET_TYPE_LABELS = {
  [EnumRedPacketType.LUCKY]: '拼手气红包',
  [EnumRedPacketType.NORMAL]: '普通红包',
  [EnumRedPacketType.EXCLUSIVE]: '专属红包',
}
// 项目分类id
export enum EnumCategoryType {
  // 礼物
  GIFT = '9',
  // 项目
  PROJECT = '2',
}

/**
 * SKU项目状态
 */
export enum EnumSkuStatus {
  Close = 'CLOSE',
  Normal = 'NORMAL',
  UnderReview = 'UNDER_REVIEW',
}
